export const positionOptions = [
  { value: 'GK', label: 'Goalkeeper (GK)' },
  { value: 'RB', label: 'Right Back (RB)' },
  { value: 'CB', label: 'Centre Back (CB)' },
  { value: 'LB', label: 'Left Back (LB)' },
  { value: 'RM', label: 'Right Midfield (RM)' },
  { value: 'CM', label: 'Centre Midfield (CM)' },
  { value: 'LM', label: 'Left Midfield (LM)' },
  { value: 'RW', label: 'Right Wing (RW)' },
  { value: 'LW', label: 'Left Wing (LW)' },
  { value: 'CAM', label: 'Central Attacking Midfield (CAM)' },
  { value: 'CDM', label: 'Central Defensive Midfield (CDM)' },
  { value: 'ST', label: 'Striker (ST)' },
  { value: 'CF', label: 'Centre Forward (CF)' },
  { value: 'SS', label: 'Second Striker (SS)' },
];
// utils/playerUtils.ts

export const getInitials = (fullName: string): string => {
  const parts = fullName.trim().split(' ');
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

export const getPositionGroup = (
  position: string
): 'goalkeeper' | 'defender' | 'midfielder' | 'attacker' => {
  const gk = ['GK'];
  const def = ['CB', 'LB', 'RB', 'LCB', 'RCB', 'LWB', 'RWB'];
  const mid = ['CM', 'CDM', 'CAM', 'LM', 'RM', 'LCM', 'RCM'];
  const att = ['ST', 'CF', 'LW', 'RW', 'LS', 'RS'];

  if (gk.includes(position)) return 'goalkeeper';
  if (def.includes(position)) return 'defender';
  if (mid.includes(position)) return 'midfielder';
  return 'attacker';
};

export const getSuitabilityColor = (
  positions: string[] = [],
  targetGroup: 'goalkeeper' | 'defender' | 'midfielder' | 'attacker',
  targetRole?: string
): string => {
  if (!positions.length || !targetRole) return 'red';

  const hasExactMatch = positions.includes(targetRole);
  if (hasExactMatch) return '#003366'; // Dark blue = exact match

  const positionGroups = positions.map(pos => getPositionGroup(pos));
  if (positionGroups.includes(targetGroup)) return 'orange'; // Orange = same group

  return 'red'; // Red = out of position
};

export const initialPositions: Position[] = [
  { id: 'GK', role: 'GK', x: 47, y: 5 },
  { id: 'RB', role: 'RB', x: 5, y: 25 },
  { id: 'CB1', role: 'CB', x: 60, y: 25 },
  { id: 'CB2', role: 'CB', x: 35, y: 25 },
  { id: 'LB', role: 'LB', x: 90, y: 25 },
  { id: 'RM', role: 'RM', x: 5, y: 50 },
  { id: 'CM1', role: 'CM', x: 60, y: 50 },
  { id: 'CM2', role: 'CM', x: 35, y: 50 },
  { id: 'LM', role: 'LM', x: 90, y: 50 },
  { id: 'ST1', role: 'ST', x: 35, y: 75 },
  { id: 'ST2', role: 'ST', x: 60, y: 75 },
];

export interface Player {
  id: string;
  firstName: string;
  lastName: string;
  positions: string[];
  shirtNumber: number;
}

export interface AssignedPlayer {
  playerId: string;
  initials: string;
  color: string;
}

export interface Position {
  id: string;
  role: string;
  x: number;
  y: number;
  assigned?: AssignedPlayer;
}
